import React, { useState, useEffect } from "react";
import "./footer1.css";
import { Link } from "react-router-dom"; // Use react-router for routing
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebookF,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import ScrollArrow from "./scroll-arrow";
import CookieNotice from "./CookieNotice";
import AccessibilityWidget from "./AccessibilityWidget/components/AccessibilityWidget";
import Aos from "aos";
import "aos/dist/aos.css";

import logo from "../assets/logo-footer.webp"; 
import footerDesktop from "../assets/footer-img.webp";
import footerMobile from "../assets/footer-img.webp";
import BestWebLogo from "./BestwebLogo/BestWebLogo";

export default function Footer1() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  useEffect(() => {
    const lazyElements = document.querySelectorAll(".lazy-bg");

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const bg = el.getAttribute("data-bg");

          if (bg) {
            el.style.backgroundImage = `url(${bg})`;
            el.classList.add("loaded");
            el.classList.remove("lazy-bg");
            obs.unobserve(el);
          }
        }
      });
    });

    lazyElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  //   const getFooterBackground = () => {
  //     return window.innerWidth <= 500
  //       ? "/assets/footer-mobile.webp"
  //       : "/assets/footer.webp";
  //   };
  const getFooterBackground = () => {
    return window.innerWidth <= 500 ? footerMobile : footerDesktop;
  };

  return (
    <div>
      <ScrollArrow />
      <AccessibilityWidget />
      <CookieNotice />
      <div
        className="footer-content lazy-bg"
        style={{ backgroundImage: `url(${getFooterBackground()})` }}
      >
        <br />
        <div className="footer-data-content">
          <div className="footer-2-column-container">
            <div className="footer-2-column left-column">
              <div className="footer-logo">
                <Link to="/">
                  <img
                    className="footer-logo-img"
                    alt="logo"
                    src={logo}
                    loading="lazy"
                  />
                </Link>
                <BestWebLogo />
              </div>
            </div>
            <div className="footer-2-column right-column">
              <div className="three-column-wrapper">
                <div className="three-column-paragraph column-1">
                  <h3>Explore</h3>
                  <Link to="/conserve/">Conserve</Link>
                  <br />
                  <Link to="/empower/">Empower</Link>
                  <br />
                  <Link to="/support/">Support</Link>
                  <br />
                  <Link to="/trust">Trust</Link>
                  <br />
                  <Link to="/contact-us/">Contact Us</Link>
                </div>
                {/* <div className="three-column-paragraph column-2">
                  <h3>Company</h3>
                  <Link to="/">Apparel</Link><br />
                  <Link to="/corporate/">Corporate</Link><br />
                  <Link to="/legacy/">Our Legacy</Link><br />
                  <Link to="/corporate-leadership/">Corporate Leadership</Link><br />
                  <Link to="/apparel-leadership/">Apparel Leadership</Link><br />
                  <Link to="/our-capabilities/">Our Capabilities</Link>
                </div> */}
                <div className="three-column-paragraph column-3">
                  <h3>Support</h3>
                  <Link to="/cookies-policy/">Cookie Policy</Link>
                  <br />
                  <Link to="/privacy-policy/">Privacy Policy</Link>
                  <br />
                  <Link to="/sitemap/">Sitemap</Link>
                  <br />
                  <Link to="/faq/">FAQ</Link>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-2-column-container mobile-icone">
            <div className="footer-2-column left-column">
              <div className="footer-link">
                <a href="http://3cs.lk" target="_blank" rel="noreferrer">
                  Web Design by 3CS
                </a>{" "}
                | Copyright © {currentYear}{" "}
                <span style={{ color: "#000" }}>Hirdaramani Group</span>
              </div>
            </div>
            <div className="footer-2-column right-column">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <div className="new-footer-social-icon">
                  <a
                    aria-label="facebook"
                    href="https://www.facebook.com/HirdaramaniGroup/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-media"
                  >
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>
                  <a
                    aria-label="instagram"
                    href="https://www.instagram.com/hirdaramanigroup/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-media"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                  <a
                    aria-label="youtube"
                    href="https://www.youtube.com/channel/UCS8MIl0YX4y5hRI7JkXoUOw"
                    className="social-media"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                  <a
                    aria-label="linkedin"
                    href="https://www.linkedin.com/company/hirdaramani-group-of-companies/"
                    className="social-media"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                  <a
                    aria-label="email"
                    href="mailto:info@hirdaramani.com"
                    target="_blank"
                    rel="noreferrer"
                    className="social-media"
                  >
                    <FontAwesomeIcon icon={faEnvelope} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  );
}
